import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { SocialProofPopup } from './components/SocialProofPopup';
import { HeroSection } from './components/HeroSection';
import { ProductCarousel } from './components/ProductCarousel';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { KitDetails } from './components/KitDetails';
import { BeforeAfter } from './components/BeforeAfter';
import { BonusSection } from './components/BonusSection';
import { SecretBonuses } from './components/SecretBonuses';
import { SummarySection } from './components/SummarySection';
import { SocialProof } from './components/SocialProof';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    // Facebook Domain Verification meta tag
    const metaTag = document.createElement('meta');
    metaTag.name = 'facebook-domain-verification';
    metaTag.content = 'kwval4sae61hvay6e52c7wtcmmsuag';
    document.head.appendChild(metaTag);
    // Meta Pixel Code - ID: 1265894175478046
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      w.fbq('init', '1265894175478046');
      w.fbq('track', 'PageView');
    } catch (e) {
      // Pixel failed to load - page continues working
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-yellow-300 selection:text-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <SocialProofPopup data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProductCarousel data-id="element-5" />
        <PainPoints data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <KitDetails data-id="element-8" />
        <BeforeAfter data-id="element-9" />
        <BonusSection data-id="element-10" />
        <SecretBonuses data-id="element-11" />
        <SummarySection data-id="element-12" />
        <SocialProof data-id="element-13" />
        <PricingSection data-id="element-14" />
        <GuaranteeSection data-id="element-15" />
        <FAQSection data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>

      <FooterSection data-id="element-18" />
    </div>;
}